/**
 * ============================================================
 * EU-WIDERRUFSBUTTON – JavaScript v2.0 (FINAL)
 * Datei: assets/widerruf.js
 *
 * Strategie:
 * - Kein Ajax mehr – normaler Shopify-Formular-Submit
 * - Shopify leitet nach Submit auf ?success=1 weiter
 * - Dieses Script erkennt ?success=1 und zeigt Schritt 3
 * - Zeitstempel wird beim Laden der Bestätigungsseite gesetzt
 * ============================================================
 */

(function () {
  'use strict';

  var CONFIG = {
    stepIds: { step1: 'widerruf-step-1', step2: 'widerruf-step-2', step3: 'widerruf-step-3' },
    formId: 'widerruf-form',
    submitBtnId: 'btn-widerruf-bestaetigen',
    timestampId: 'widerruf-timestamp',
    fields: { name: 'widerruf-name', email: 'widerruf-email', bestellnummer: 'widerruf-bestellnummer' },
    errorClass: 'widerruf-form__input--error',
    errorMsgClass: 'widerruf-form__error-msg',
    errorMsgVisibleClass: 'widerruf-form__error-msg--visible',
    activeClass: 'widerruf-step--active',
  };

  // ── Schritt-Steuerung ──────────────────────────────────────
  function zeigeSchritt(activeStepId) {
    Object.values(CONFIG.stepIds).forEach(function (stepId) {
      var el = document.getElementById(stepId);
      if (!el) return;
      if (stepId === activeStepId) {
        el.classList.add(CONFIG.activeClass);
        el.style.display = 'block';
        el.removeAttribute('aria-hidden');
        setTimeout(function () {
          var t = el.querySelector('h1, button, input, [tabindex="0"]');
          if (t) t.focus({ preventScroll: false });
        }, 50);
      } else {
        el.classList.remove(CONFIG.activeClass);
        el.style.display = 'none';
        el.setAttribute('aria-hidden', 'true');
      }
    });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  // ── Validierung ────────────────────────────────────────────
  function validiereField(input, msg) {
    if (!input) return true;
    var ok = input.value.trim() !== '';
    if (input.type === 'email' && ok) ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value.trim());
    input.classList.toggle(CONFIG.errorClass, !ok);
    if (ok) input.removeAttribute('aria-invalid'); else input.setAttribute('aria-invalid', 'true');
    var errEl = input.parentNode.querySelector('.' + CONFIG.errorMsgClass);
    if (errEl) { errEl.textContent = ok ? '' : msg; errEl.classList.toggle(CONFIG.errorMsgVisibleClass, !ok); }
    return ok;
  }

  function validiereFormular() {
    var n = document.getElementById(CONFIG.fields.name);
    var e = document.getElementById(CONFIG.fields.email);
    var b = document.getElementById(CONFIG.fields.bestellnummer);
    var nOk = validiereField(n, 'Bitte geben Sie Ihren vollständigen Namen an.');
    var eOk = validiereField(e, 'Bitte geben Sie eine gültige E-Mail-Adresse an.');
    var bOk = validiereField(b, 'Bitte geben Sie Ihre Bestellnummer an.');
    if (!nOk && n) n.focus(); else if (!eOk && e) e.focus(); else if (!bOk && b) b.focus();
    return nOk && eOk && bOk;
  }

  function erstelleFehlermeldungsElemente() {
    Object.values(CONFIG.fields).forEach(function (id) {
      var input = document.getElementById(id);
      if (!input || input.parentNode.querySelector('.' + CONFIG.errorMsgClass)) return;
      var el = document.createElement('span');
      el.className = CONFIG.errorMsgClass;
      el.setAttribute('role', 'alert');
      el.setAttribute('aria-live', 'polite');
      input.parentNode.insertBefore(el, input.nextSibling);
    });
  }

  // ── Lade-Indikator ─────────────────────────────────────────
  function setzeSubmitButtonLaden(isLoading) {
    var btn = document.getElementById(CONFIG.submitBtnId);
    if (!btn) return;
    if (isLoading) {
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      btn.dataset.originalHtml = btn.innerHTML;
      btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="widerruf-btn__icon" style="animation:widerruf-spin 1s linear infinite" aria-hidden="true"><path d="M21 12a9 9 0 1 1-6.219-8.56"/></svg> Wird gesendet\u2026';
    } else {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      if (btn.dataset.originalHtml) btn.innerHTML = btn.dataset.originalHtml;
    }
  }

  // ── Datum formatieren ──────────────────────────────────────
  function formatiereDatum() {
    var now = new Date();
    var p = function(n){ return n < 10 ? '0'+n : n; };
    return p(now.getDate())+'.'+p(now.getMonth()+1)+'.'+now.getFullYear()+
           ' um '+p(now.getHours())+':'+p(now.getMinutes())+':'+p(now.getSeconds())+' Uhr';
  }

  // ── URL-Parameter lesen ────────────────────────────────────
  function getUrlParam(name) {
    var params = new URLSearchParams(window.location.search);
    return params.get(name);
  }

  // ── Öffentliche API ────────────────────────────────────────
  window.widerrufsbutton = {
    zeigeEinstieg:     function () { zeigeSchritt(CONFIG.stepIds.step1); },
    zeigeFormular:     function () { zeigeSchritt(CONFIG.stepIds.step2); },
    zeigeBestaetigung: function () { zeigeSchritt(CONFIG.stepIds.step3); },
  };

  // ── Initialisierung ────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', function () {

    erstelleFehlermeldungsElemente();

    // Prüfe ob Shopify nach erfolgreichem Submit auf ?success=1 weitergeleitet hat
    if (getUrlParam('success') === '1') {
      // Zeitstempel setzen
      var tsEl = document.getElementById(CONFIG.timestampId);
      if (tsEl) tsEl.textContent = formatiereDatum();
      // Bestätigungsseite anzeigen
      zeigeSchritt(CONFIG.stepIds.step3);
      // URL bereinigen (ohne Seitenreload)
      if (window.history && window.history.replaceState) {
        window.history.replaceState({}, document.title, window.location.pathname);
      }
      return; // Keine weitere Initialisierung nötig
    }

    // Formular-Validierung vor dem Submit
    var form = document.getElementById(CONFIG.formId);
    if (form) {
      var hasSubmitted = false;

      form.addEventListener('submit', function (e) {
        hasSubmitted = true;
        var isValid = validiereFormular();
        if (!isValid) {
          e.preventDefault();
          return false;
        }
        // Lade-Indikator anzeigen (Seite wird gleich neu geladen)
        setzeSubmitButtonLaden(true);
      });

      // Live-Validierung nach erstem Submit-Versuch
      [CONFIG.fields.name, CONFIG.fields.email, CONFIG.fields.bestellnummer].forEach(function (id) {
        var input = document.getElementById(id);
        if (!input) return;
        input.addEventListener('input', function () {
          if (!hasSubmitted) return;
          var msgs = {};
          msgs[CONFIG.fields.name]          = 'Bitte geben Sie Ihren vollständigen Namen an.';
          msgs[CONFIG.fields.email]         = 'Bitte geben Sie eine gültige E-Mail-Adresse an.';
          msgs[CONFIG.fields.bestellnummer] = 'Bitte geben Sie Ihre Bestellnummer an.';
          validiereField(input, msgs[id]);
        });
      });
    }

    // Spin-Animation
    if (!document.getElementById('widerruf-spin-style')) {
      var s = document.createElement('style');
      s.id = 'widerruf-spin-style';
      s.textContent = '@keyframes widerruf-spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}';
      document.head.appendChild(s);
    }

  });

})();